import styled, { keyframes } from "styled-components";

const Anim = keyframes`

    from{
        transform: rotateY(0deg);
        
    }
    to{
        transform: rotateY(360deg);
    }

`;

export const Logo = styled.div`
  animation: ${Anim} 4s linear infinite;
  height: 100px;
  width: 100px;
  background-image: url(/images/logo-bocchi.png);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;
